import { withVariants } from '@udecode/cn';
import { cva,type VariantProps } from 'class-variance-authority';
import React from 'react';

export const inputVariants = cva(
    'flex w-full rounded-md text-base placeholder:gray-500 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-all duration-200',
    {
        defaultVariants: {
            h: 'md',
            variant: 'default',
        },
        variants: {
            h: {
                md: 'h-10 px-3 py-2',
                sm: 'h-[28px] px-1.5 py-1',
            },
            variant: {
                default: 'bg-red-500',
                ghost: 'border-none outline-none focus:ring-0',
            },
        },
    }
);

export type InputProps = React.ComponentPropsWithoutRef<'input'> &
  VariantProps<typeof inputVariants>;

export const Input = withVariants('input', inputVariants, ['variant', 'h']);

export type FloatingInputProps = InputProps & {
  label: string;

};

export function FloatingInput({
    id,
    className,
    label,
    ...props
}: FloatingInputProps) {
    return (
        <>
            <label
                className="absolute top-1/2 block -translate-y-1/2 cursor-text px-1 text-sm text-gray-500/70 transition-all group-focus-within:pointer-events-none group-focus-within:top-0 group-focus-within:cursor-default group-focus-within:text-xs group-focus-within:font-medium group-focus-within:text-foreground has-[+input:not(:placeholder-shown)]:pointer-events-none has-[+input:not(:placeholder-shown)]:top-0 has-[+input:not(:placeholder-shown)]:cursor-default has-[+input:not(:placeholder-shown)]:text-xs has-[+input:not(:placeholder-shown)]:font-medium has-[+input:not(:placeholder-shown)]:text-foreground"
                htmlFor={id}
            >
                <span className="inline-flex bg-gray-100 px-2">{label}</span>
            </label>
            <Input id={id} className={className} placeholder="" {...props} />
        </>
    );
}
